export default __webpack_public_path__ + "static/media/squirtle.5406ef59.png";